module.exports = __webpack_public_path__ + "img/Logo Colored-4@2x.ca0d3c1f.png";